<template>
    <div class="row darker fs-small font-weight-600">

        <div class="d-flex w-100 mb-1">
            <div class="col-sm-4">
                <label>Product:</label>
                <span>{{reservation.event.product.name}}</span>
            </div>

            <div class="col-sm-4">
                <label>Location:</label>
                <span v-if="reservation.event.location">{{reservation.event.location}}</span>
            </div>

            <div class="col-sm-4">
                <label>Status:</label>
                <change-status-btn v-model="reservation" :disabled="disabled || accessPermissionFilter(['restricted'])"></change-status-btn>
                <!-- <span v-if="reservation.status == 1">{{reservation.statusDescription}}</span>
                <span v-else-if="reservation.status == -5" class="lightest bg-color-6 radius-normal px-2 py-1">{{reservation.statusDescription}}</span>
                <span v-else-if="reservation.status == 30" @click="openReservation(reservation.parentBookingId)" class="pointer"><span class="lightest bg-color-2 radius-normal px-2 py-1">{{reservation.statusDescription}}</span> from {{formatTicketNumber(reservation.parentBookingId)}}</span>
                <span v-else>{{reservation.statusDescription}}</span> -->
            </div>
        </div>

        <div class="d-flex w-100">
            <div class="col-sm-4">
                <label>Date/Time:</label>
                <span>{{ reservationDate }} ({{eventDuration}})</span>
            </div>

            <div class="col-sm-4 d-flex">
                <label>Resource{{reservation.event.eventResources.length > 1? 's':''}}:</label>
                <!-- <span>{{ resources(reservation.event) }}</span> -->
                <v-select class="editReservationResourceDropdown" :disabled="disabled || accessPermissionFilter(['restricted'])" :options="resourcesWithAvailability" label="name" v-model="reservation.selectedResource"></v-select>
            </div>

            <div class="col-sm-4 d-flex align-items-top">
                <label>Seller:</label>
                <span v-if="reservation.channelType >= 100 && reservation.channelType <= 102">Widget</span>
                <span v-else-if="reservation.channelType == 201">Pluralo Locals</span>
                <span v-else-if="reservation.channelType == 202">Get Your Guide</span>
                <span  v-else-if="!changingSeller" :class="{pointer: canChangeSeller}" @click="showEditSeller">
                    {{reservation.creatorAgent? reservation.creatorAgent.brandName : reservation.creatorUserAccount? reservation.creatorUserAccount.name : ''}}
                    <i class="ico ico-edit dark mr-0 ml-1 fs-small" v-if="canChangeSeller"></i>
                </span>
                <span v-else-if="changingSeller && canChangeSeller" class="editReservationSellerPicker">
                    <seller-picker size="small" :reservation="reservation" :orignalSeller="reservation.creatorAgent? reservation.creatorAgent : reservation.creatorUserAccount" :agentList="eventPossibleAgentsList(reservation.event)" @input="sellerChanged"></seller-picker>
                </span>
            </div>
        </div>

    </div>
</template>

<script>
import extendedVSelect from '@/extends/vue-select'
import { reservationsMixin } from '@/mixins/reservations'
import {mapGetters, mapActions} from 'vuex'
import SellerPicker from '../../SellerPicker'
import changeStatusBtn from '@/tools/reservation/changeStatusBtn'
import {eventMixin} from '@/mixins/event'

export default {
    data: function() {
        return {
            changingSeller: false
        }
    },
    props: {
        reservation: {
            type: Object
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters([
            'account',
        ]),
        canChangeSeller: function () {
            return this.accessPermissionFilter(['admin', 'supervisor'])
        },
        reservationDate: function() {
            return this.formatDateDots(this.reservation.eventDate)+' '+this.formatTime(this.reservation.eventDate)
        },
        eventDuration: function() {
            let start = moment(this.reservation.event.start)
            let end = moment(this.reservation.event.end)
            let durationSeconds = end.diff(start, 'seconds');
            let momentDuration = moment.utc(durationSeconds*1000)
            return momentDuration.format("HH")+'h'+momentDuration.format("mm")
        },
    },
    mixins:[
        reservationsMixin,
        eventMixin
    ],
    methods: {
        ...mapActions([
            'setReservationCalculations',
            'resetCalculationsGuid',
            'openReservationById',
            'closeModal'
        ]),
        sellerChanged: function(newSeller) {
            console.log(newSeller);
            this.$set(this.reservation.updateFlags, 'reservation', true)
            this.resetCalculationsGuid()
            this.reservation.calculationsGUID = null

            this.changingSeller = false

            this.$set(this.reservation, 'attachCommission', {
                isToOverwriteComponent: false,
                isToOverwriteProduct: false,
                isToOverwriteProductComponent: false,
                isToOverwriteTransport: false
            })

            this.setReservationCalculations(this.reservation).then(response => {
                // console.log('herez: ',response);
                this.$set(this.reservation, 'attachCommission', response.data.attachCommission);

                //fix2
                this.reservation.attachCommussion.isToOverwriteComponent= false,
                this.reservation.attachCommussion.isToOverwriteProduct= false,
                this.reservation.attachCommussion.isToOverwriteProductComponent= false,
                this.reservation.attachCommussion.isToOverwriteTransport= false
            })

            this.reservation.updateFlags.reservation = true
        },
        showEditSeller: function(){
            if(this.disabled){
                return false
            }

            if(this.isReservationReadOnly && this.reservation.status != 5){
                this.readOnlyShowMessage()
                return false
            }

            if(this.canChangeSeller){
                this.changingSeller = true
            }
        },
        openReservation: function (targetReservationId) {
            this.closeModal()
            this.openReservationById(targetReservationId)
        },
        resources: function(event) {
            let resourcesNames = [];

            for (let resource of event.eventResources) {
                resourcesNames.push(resource.name);
            }

            let resourcesString = resourcesNames.join(', ');

            return resourcesString;
        }
    },
    components: {
        SellerPicker,
        changeStatusBtn,
        vSelect: extendedVSelect
    }
}
</script>

<style lang="scss" scoped>
label{
    min-width: 70px;
}
</style>

<style lang="scss">
@import '../../../assets/scss/_variables.scss';
@import '../../../assets/scss/_utility.scss';

.editReservationResourceDropdown{
    .dropdown-toggle{
        height: 1.5rem !important;

        .vs__actions{
            top: 3px !important;
        }

        .selected-tag{
            height: 1.4rem !important;
            margin: 0 !important;
            line-height: 1.4rem !important;
        }
    }

    .open-indicator{
        height: 14px !important;
    }
}
.editReservationSellerPicker{
    z-index: 3;
    width: 100%;
    .sellerPickerHolder{

        .multiselect{
            border: none !important;
            background: none !important;
            padding: 0 !important;

            .multiselect__tags{

                .multiselect__single, .multiselect__input{
                    // background: none;
                    @extend .radius-normal;
                    @extend .border-light;
                    padding: 0 0.5rem;

                }
            }

            .multiselect__input{
            }

            .multiselect__select{
                height: 100%;
                width: auto;

                &:before{
                    top: -4px;
                }
            }

        }
    }
}
</style>



// WEBPACK FOOTER //
// TopArea.vue?e373c694